import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

// Filter + sort state that parameterizes a paginated list query key. Mirrors
// `DataGridQuery` from `@/hooks/use-data-grid`; kept structural to avoid a cycle.
interface ListKeyFilters {
  search?: string;
  status?: string;
  sort?: string;
  sortDir?: string;
}

// Reference entity (src/examples/widget). One factory per domain; mirror this
// shape for a real entity and invalidate via `*.all` after mutations.
export const widgetKeys = {
  all: ["widgets"] as const,
  list: (filters: ListKeyFilters) => ["widgets", "list", filters] as const,
  detail: (id: string) => ["widgets", "detail", id] as const,
};

export const fileKeys = {
  all: ["files"] as const,
  list: (filters: ListKeyFilters) => ["files", "list", filters] as const,
  detail: (id: string) => ["files", "detail", id] as const,
} as const;

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const devKeys = {
  seedAccounts: ["dev", "seed-accounts"] as const,
} as const;

export const emailKeys = {
  all: ["email"] as const,
  outbox: () => ["email", "outbox"] as const,
  templates: () => ["email", "templates"] as const,
  template: (key: string) => ["email", "templates", key] as const,
} as const;

export const auditKeys = {
  all: ["audit"] as const,
  list: (filters: ListKeyFilters) => ["audit", "list", filters] as const,
} as const;
